import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatLegacyDialogRef as MatDialogRef} from "@angular/material/legacy-dialog";
import {Attachment, AttachmentSource} from '@docma-mm-core/attachment/attachment';
import {LoadState} from '@docma-mm-core/model/load-state/load-state';
import {LoadStatusEnum} from '@docma-mm-core/model/load-state/load-state.enum';
import {ChangeState} from '@docma-mm-core/model/change-state/change-state';
import {AttachmentService} from '@docma-mm-core/attachment/attachment.service';

@Component({
  selector: 'mydocma-mm-mm-fault-camera-picture-dialog',
  templateUrl: './mm-fault-camera-picture-dialog.component.html',
  styleUrls: ['./mm-fault-camera-picture-dialog.component.scss']
})
export class MmFaultCameraPictureDialogComponent implements OnInit, OnDestroy, AfterViewInit {


  isWebcamActive = true;
  isSnapshotActive =  false;
  isLoading = true;
  videoWidth: number;
  videoHeight: number;
  noAccessToWebcam = false;
  context: any;
  video: any;
  stream: any;
  attachment: Attachment;
  @ViewChild('webcam', {static: true}) webcam: ElementRef;
  @ViewChild('snapshot', {static: true}) snapshot: ElementRef;

  constructor(private readonly dialogRef: MatDialogRef<MmFaultCameraPictureDialogComponent>,
              private readonly attachmentService: AttachmentService ) { }



  ngAfterViewInit() {
    this.startWebcam();
    this.context = this.snapshot.nativeElement.getContext('2d');
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.stopWebcam();
  }

  startWebcam() {
    this.isSnapshotActive = false;
    this.isWebcamActive = true;
    this.noAccessToWebcam = false;
    this.isLoading = true;

    this.video = this.webcam.nativeElement;
    const n = <any>navigator;

    n.getUserMedia = (n.getUserMedia || n.webkitGetUserMedia || n.mozGetUserMedia || n.msGetUserMedia);
    n.mediaDevices.getUserMedia({ video: true }).then(stream => {
      this.noAccessToWebcam = false;
      this.stream = stream;
      this.isLoading =  false;
      if (stream.active) {
        this.video.srcObject = stream;
        this.video.play();
      }
    }, error => {
      this.noAccessToWebcam = true;
      this.isLoading =  false;
    });
  }

  stopWebcam() {
    if (this.video) {
      this.video.pause();
      this.video.src = '';
      this.video.srcObject = null;
    }
    if (this.stream) {
      this.stream.getTracks()[0].stop();
    }
  }

  async takePhoto() {
    this.isWebcamActive = false;
    this.isSnapshotActive = true;
    this.videoWidth = this.webcam.nativeElement.offsetWidth;
    this.videoHeight = this.webcam.nativeElement.offsetHeight;

    this.snapshot.nativeElement.width = this.videoWidth;
    this.snapshot.nativeElement.height = this.videoHeight;

    this.context.drawImage(this.webcam.nativeElement, 0, 0, this.videoWidth, this.videoHeight);
    this.snapshot.nativeElement.toBlob(async (blob) => {
      this.attachment =  await this.attachmentService.createNewAttachment();
      const attachmentDate = this.attachment.changeState.data;
      attachmentDate.MimeType = 'image/png';
      attachmentDate.Size =  blob.size;
      attachmentDate.Date = this.attachment.changeState.date;
      this.attachment.changeState = new ChangeState(this.attachment.changeState);
      this.attachment.source = new AttachmentSource();
      this.attachment.source.loadState = new LoadState({status: LoadStatusEnum.Loaded});
      const file = new File([blob], 'Foto.png', {lastModified: this.attachment.changeState.date.getTime() });
      this.attachmentService.setAttachmentSource(this.attachment.source, file);
    });
  }

  next() {
    this.stopWebcam();
    this.dialogRef.close(this.attachment);
  }

  cancel() {
    this.stopWebcam();
    this.dialogRef.close(null);
  }


}
